import angular from 'angular';

/**
 * @returns {Object}
 */
export function responsiveTabs($compile) {
    
    return {
        restrict: 'A',
        link: ($scope, $element, attr) => {
            
            var tabsOverflow = (value) => {
                
                $element.children('li.overflow').remove();
                
                $element.children('li.active').eq(0).removeClass('hidden');
                
                let childWidth = 60 + $element.children('li.active').eq(0).outerWidth();
                
                const elementWidth = $element.width();
                
                $element.children('li:not(.active)').each((index, child) => {
                    
                    child = angular.element(child);
                    
                    childWidth += child.outerWidth();
                    
                    if (childWidth > elementWidth) {
                        
                        child.addClass('hidden');
                        
                    } else {
                        
                        child.removeClass('hidden');
                    }
                });
                
                if (childWidth > elementWidth) {
                    
                    const container = angular.element(document.createElement('div'));
                    
                    container.addClass('tabs-overflow-list');
                    
                    container.attr('ui-sortable', '$ctrl.verticalSortableOptions');
                    container.attr('ng-model', '$ctrl.accommodationTypes');
                    
                    container.append('<a class="nav-link" ng-class="{active: $ctrl.selectedTab == $index}" ng-repeat="type in $ctrl.accommodationTypes" ng-click="$ctrl.openForm($index)">{{ $ctrl.getTabName($index) }}</a>');
                    
                    $compile(container)($scope);
                    
                    const button = angular.element(document.createElement('li'));
                    
                    button.addClass('uib-tab nav-item overflow');
                    
                    button.append('<a class="nav-link"><div class="tab-heading"><i class="icon-angle-down"></i></div></a>')
                    
                    button.append(container);
                    
                    $element.append(button);
                }
            };
            
            attr.$observe('responsiveTabs', tabsOverflow);
            
            let timer = null;
            angular.element(window).off('resize').on('resize', () => {
                
                if (timer) {
                    
                    window.clearTimeout(timer);
                }
                
                timer = window.setTimeout(tabsOverflow, 200);
            });
        }
    };
}

responsiveTabs.$inject = [ '$compile' ];


// WEBPACK FOOTER //
// ./src/ui/directives/responsive-tabs.directive.js